import React, { Component } from 'react';
import styles from './TextInput.scss';
import { noop } from 'lodash';

class TextInput extends Component {
  onTextChange = event => {
    const { onChange } = this.props;
    onChange(event.target.value);
  };

  onKeyUp = event => {
    if (event.which === 13) {
      this.ref.blur();
    }
  };

  componentDidUpdate(prevProps) {
    const { isHidden: isHiddenCurrent } = this.props;
    const { isHidden } = prevProps;
    if (isHidden === true && isHiddenCurrent === false) {
      this.ref.focus();
    }
  }

  render() {
    const { value, label, className, placeholder, onFocus = noop } = this.props;
    return (
      <div className={styles.container}>
        {!!label && <div className={styles.label}>{label}</div>}
        <div className={styles.textInput}>
          <input
            placeholder={placeholder}
            ref={ref => (this.ref = ref)}
            className={className}
            type="text"
            value={value}
            onChange={this.onTextChange}
            onKeyUp={this.onKeyUp}
            onFocus={onFocus}
            maxLength={20}
          />
        </div>
      </div>
    );
  }
}

export default TextInput;
